import React from "react";
import "./Portfolio.css";
import Card from "./Card";
import Portfolio_Data from "./Portfolio_Data";
// import Portfolio_Data from "./Portfolio_Data"

const Portfolio = () => {
  return (
    <section className="Portfolio top" id="portfolio">
      <div className="container">
        <div className="heading text-center ">
          <h4>VISIT MY PORTFOLIO AND KEEP YOUR FEEDBACK</h4>
          <h1>My Portfolio</h1>
        </div>

        <div className="content grid">
          {Portfolio_Data.map((data, index) => {
            return <Card key={index} data={data} />;
          })}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
